import Home from './renderers/home';
import Page from './renderers/page';
import About from './renderers/about';
import Oeuvre from './renderers/oeuvre';
import Contact from './renderers/contact';
import Nav from './components/nav';
import Sidebar from './components/sidebar';
import Cursor from './components/cursor';

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    const classes = document.body.classList;
    switch ( true ) {
		case classes.contains('home'):
			new Home();
		break;

		case classes.contains('page-template-contact'):
			new Contact();
		break;

        case classes.contains('page-template-page-about'):
            new About();
        break;

        case classes.contains('post-type-archive-oeuvres'):
            new Oeuvre();
        break;

		default:
			new Page();
	}

    new Nav();
    new Sidebar();
    
    // Cursor.init();
});